import _ from 'lodash';
import $ from 'jquery';

import config from '../config';
import constants from './constants';
import appOptions from './appOptions';
import logger from './logger';
import travelerFeeHelper from './travelerFee';
import utility from './utility';
import nativeAnalytics from './nativeAnalytics';
import CardTypeUtil from './card-type';
import tcEventsList from './tagCommanderSpecificEvents';

let analyticsEnabled = true;

const tcAnalytics = {
    hasDisplayRule(attr, model) {
        if (
            _.isUndefined(model) ||
            _.isUndefined(model.displayRules) ||
            _.isUndefined(model.displayRules[attr]) ||
            _.isNull(model.displayRules[attr])
        ) {
            return false;
        }
        return true;
    },

    getReviewSuperlativeTagging(listingInfo) {
        const avgRating = _.get(listingInfo, 'averageRating');

        if (
            !_.isNumber(avgRating) ||
            _.get(listingInfo, 'reviewCount', 0) <= 5
        ) {
            // No rating
            return 'revsup0';
        }

        const rating = _.round(avgRating, 1);
        return rating === 5
            ? 'revsup5'
            : rating >= 4.8
            ? 'revsup4'
            : rating >= 4.3
            ? 'revsup3'
            : rating >= 4.0
            ? 'revsup2'
            : rating >= 3.7
            ? 'revsup1'
            : 'revsup0';
    },

    buildTestAttributes(checkoutModel = {}) {
        let testAttributes = [];
        let products;
        let productGuids;

        if (!_.isUndefined(checkoutModel)) {
            // attach eligible vas products for this checkout
            if (checkoutModel) {
                productGuids = _.map(
                    checkoutModel.vasInterstitialProducts,
                    'productGuid'
                );
                testAttributes = testAttributes.concat(productGuids);
            } else if (
                !_.isUndefined(checkoutModel.eligibleProducts) &&
                !_.isUndefined(checkoutModel.eligibleProducts.countries) &&
                checkoutModel.eligibleProducts.countries.length > 0
            ) {
                products = checkoutModel.eligibleProducts.countries[0].products;
                productGuids = _.chain(products)
                    .map('productGuid')
                    .filter(
                        (productGuid) =>
                            productGuid.toUpperCase() !== constants.VAS.PDP
                    )
                    .value();
                testAttributes = testAttributes.concat(productGuids);
            }

            if (!_.isUndefined(checkoutModel.quote)) {
                // check for local currency
                if (
                    utility.isCurrencyDifferent(
                        checkoutModel.quote.currencyCode,
                        checkoutModel.quote.quoteTotals
                    )
                ) {
                    testAttributes.push('curr:1');
                } else {
                    testAttributes.push('curr:0');
                }

                // add single vs multi payment
                if (
                    _.get(checkoutModel.quote, 'numberOfPaymentRequests', 1) > 1
                ) {
                    testAttributes.push('multipay');
                } else {
                    testAttributes.push('singlepay');
                }

                // add rdd amount to test attributes
                // old logging was `rddtrue` and `rddfalse`
                // new logging is `rdd:500` and `rdd:0`
                const rddAmt =
                    (checkoutModel &&
                        checkoutModel.quote &&
                        checkoutModel.quote.refundableDamageDeposit &&
                        checkoutModel.quote.refundableDamageDeposit.amount &&
                        checkoutModel.quote.refundableDamageDeposit.amount
                            .amount) ||
                    0;

                // if no rdd then logging will be rdd:0
                // if autoRDD then rdd:500_1
                // if not autoRDD then rdd:500_0
                if (rddAmt > 0) {
                    if (
                        _.get(
                            checkoutModel,
                            'quote.damageDeposit.damageDepositType'
                        ) === constants.DAMAGE_DEPOSIT_TYPE.AUTO &&
                        checkoutModel.offlinePaymentMode !==
                            constants.offlinePaymentModes.OFFLINE
                    ) {
                        testAttributes.push(`rdd:${rddAmt}_1`);
                    } else {
                        testAttributes.push(`rdd:${rddAmt}_0`);
                    }
                } else {
                    testAttributes.push(`rdd:${rddAmt}`);
                }

                let cancellationPolicies =
                    checkoutModel.quote.cancellationPolicies;
                if (_.isObject(cancellationPolicies)) {
                    if (
                        _.find(cancellationPolicies, {
                            cancellationPolicySource:
                                constants.CANCELLATION_POLICY_SOURCES
                                    .UNIT_RENTAL_POLICY,
                        })
                    ) {
                        testAttributes.push('cancelmsg1');
                    } else {
                        testAttributes.push('cancelmsg0');
                    }
                } else {
                    testAttributes.push('cancelmsg0');
                }
            }
        }

        // check for cancellationUrgencyMessaging
        let cancellationPolicies = _.get(
            checkoutModel,
            'quote.cancellationPolicies'
        );
        if (
            this.hasDisplayRule('cancellationUrgencyMessaging', checkoutModel)
        ) {
            switch (
                checkoutModel.displayRules.cancellationUrgencyMessaging
                    .cancellationPolicySource
            ) {
                case constants.CANCELLATION_POLICY_SOURCES.UNIT_RENTAL_POLICY:
                    if (
                        _.isObject(cancellationPolicies) &&
                        cancellationPolicies[0] &&
                        cancellationPolicies[0].name
                    ) {
                        switch (
                            cancellationPolicies[0].name
                                .replace(/[^a-zA-Z0-9 ]/g, '')
                                .toUpperCase()
                        ) {
                            case constants.CANCELLATION_POLICY_TYPES.STRICT.toUpperCase():
                                testAttributes.push('cancelstr1');
                                break;
                            case constants.CANCELLATION_POLICY_TYPES.FIRM.toUpperCase():
                                testAttributes.push('cancelstr2');
                                break;
                            case constants.CANCELLATION_POLICY_TYPES.MODERATE.toUpperCase():
                                testAttributes.push('cancelstr3');
                                break;
                            case constants.CANCELLATION_POLICY_TYPES.RELAXED.toUpperCase():
                                testAttributes.push('cancelstr4');
                                break;
                            case constants.CANCELLATION_POLICY_TYPES.NON_REFUNDABLE.toUpperCase():
                                testAttributes.push('cancelstr5');
                                break;
                            default:
                                testAttributes.push('cancelstr');
                        }
                    }
                    break;
                case constants.CANCELLATION_POLICY_SOURCES.RATE_PLAN:
                    testAttributes.push('cancelnonstr');
                    break;
                default:
                    testAttributes.push('cancelnone');
            }
        } else {
            _.get(cancellationPolicies, '[0].name', '').replace(
                /[^a-zA-Z0-9 ]/g,
                ''
            ) ===
            constants.CANCELLATION_POLICY_TYPES.NON_REFUNDABLE.toUpperCase()
                ? testAttributes.push('cancelstr5')
                : testAttributes.push('cancelnone');
        }

        if (
            _.isObject(cancellationPolicies) &&
            cancellationPolicies[0] &&
            cancellationPolicies[0].cancellationPolicyValidity
        ) {
            const policyCriteria =
                cancellationPolicies[0].cancellationPolicyValidity ===
                constants.CANCELLATION_POLICY_VALIDITY.ALL_QUALIFIED
                    ? 'allqual'
                    : cancellationPolicies[0].cancellationPolicyValidity ===
                      constants.CANCELLATION_POLICY_VALIDITY.PARTIAL_QUALIFIED
                    ? 'parqual'
                    : 'nonqual';
            testAttributes.push(policyCriteria);
        }

        // check for cancellation policy according to unit_rental, rate_plan and others
        if (_.get(checkoutModel, 'quote.cancellationPolicies')) {
            if (cancellationPolicies[0] && cancellationPolicies[0].name) {
                const policyName = cancellationPolicies[0].name
                    .replace(/[^a-zA-Z0-9]/g, '')
                    .toUpperCase();
                switch (policyName) {
                    case constants.CANCELLATION_POLICY_TYPES.STRICT.toUpperCase():
                        testAttributes.push('ur1');
                        break;
                    case constants.CANCELLATION_POLICY_TYPES.FIRM.toUpperCase():
                        testAttributes.push('ur2');
                        break;
                    case constants.CANCELLATION_POLICY_TYPES.MODERATE.toUpperCase():
                        testAttributes.push('ur3');
                        break;
                    case constants.CANCELLATION_POLICY_TYPES.RELAXED.toUpperCase():
                        testAttributes.push('ur4');
                        break;
                    case constants.CANCELLATION_POLICY_TYPES.NON_REFUNDABLE.toUpperCase():
                        testAttributes.push('ur5');
                        break;
                    default:
                        break;
                }
            } else {
                const ratePlan = _.get(cancellationPolicies, '0.freeText', 0)
                    ? 'rplan'
                    : 'cancelother';
                testAttributes.push(ratePlan);
            }
        }

        if (checkoutModel && _.isObject(checkoutModel.listing)) {
            testAttributes.push(
                _.isEmpty(
                    _.get(checkoutModel, 'listing.contact.ownerProfilePhoto')
                )
                    ? 'pic0'
                    : 'pic1'
            );
            const listing = _.get(checkoutModel, 'listing', {});
            if (listing.integratedPropertyManager) {
                testAttributes.push('ipm');
            } else if (listing.ownerManaged) {
                testAttributes.push('frbo');
            } else if (listing.platformPropertyManager) {
                testAttributes.push('pm');
            }
        }

        // [CHK-735] Test attribute for vat
        if (checkoutModel && _.isObject(checkoutModel.quote?.fees)) {
            if (
                travelerFeeHelper.hasVatIncludedMsg(
                    checkoutModel.quote.fees,
                    checkoutModel.quote.complianceType
                )
            ) {
                testAttributes.push('vat1');
            } else {
                testAttributes.push('vat0');
            }
        } else {
            testAttributes.push('vat0');
        }

        if (
            _.has(checkoutModel, 'propertyInfo') &&
            _.has(checkoutModel.propertyInfo, 'checkInTime') &&
            _.has(checkoutModel.propertyInfo, 'checkOutTime')
        ) {
            testAttributes.push('ct1');
        } else {
            testAttributes.push('ct0');
        }

        // CHK-5583 Structured House Rules V3
        if (_.has(checkoutModel, 'houseRules')) {
            testAttributes.push('shr1');
        } else {
            testAttributes.push('shr0');
        }

        // CHK-1668 ecNewCheckout
        testAttributes.push('cp1');

        if (_.has(checkoutModel, 'listing')) {
            const superlativeTagging = this.getReviewSuperlativeTagging(
                checkoutModel.listing
            );
            if (superlativeTagging) {
                testAttributes.push(superlativeTagging);
            }
        } else {
            // no reviews
            testAttributes.push('revsup0');
        }

        return {
            testattributes: _.uniq(testAttributes).join(',').toLowerCase(),
        };
    },

    isValidUserInfoForCapture(data) {
        let expectedProps = [
            'firstName',
            'lastName',
            'emailAddress',
            'eventType',
        ];
        let valid = true;

        // iterate through all the expected props we require checking for null or undefined
        _.each(expectedProps, (prop) => {
            if (_.isNull(data[prop]) || _.isUndefined(data[prop])) {
                valid = false;
            }
        });
        return valid;
    },

    captureUserInfo(data) {
        let obj;
        let email = data.emailAddress;
        let marketingoptout = data.marketingoptout;

        try {
            // check if we have valid data
            if (!this.isValidUserInfoForCapture(data)) {
                return;
            }

            // set cache
            this.cache = this.cache || {};

            // create object to send to edap
            obj = {
                eventaction: data.eventType,
                marketingoptout: data.marketingoptout,
                eventstartdate: appOptions.get('checkinDate'),
                eventenddate: appOptions.get('checkoutDate'),
                eventnumadults: `${appOptions.get('adults')}`,
                eventnumchildren: `${appOptions.get('children')}`,
                eventpets:
                    typeof appOptions.get('pets') !== 'undefined'
                        ? appOptions.get('pets')
                        : '-1',
            };

            // if cache is present and marketing optout has not changed, then this means we have fired off the event already
            if (
                this.cache[email] &&
                this.cache.marketingoptout === marketingoptout
            ) {
                return;
            }

            // fire off event
            tcAnalytics.analyticsEvent('user.email.entered', obj);

            // set the cache
            this.cache[email] = true;
            this.cache.marketingoptout = marketingoptout;
        } catch (exception) {
            logger.log({
                key: 'error',
                value: 'Unable to capture user information',
            });
        }
    },

    analyticsEvent() {
        if (analyticsEnabled) {
            const args = arguments;
            window.edap.push((edapInstance) => {
                edapInstance.trigger(...args);
                tcEventsList.eventBasedTagTrigger(args);
            });
        }
    },

    disable() {
        analyticsEnabled = false;
    },

    setTagCommanderDL(analyticsDL) {
        let analyticsdatalayer = window?.analyticsdatalayer;
        let datalayerADL = Object.assign(analyticsdatalayer, analyticsDL);
        let tagCommanderPayload = this.setTagCommanderPayload(datalayerADL);
        window.commonDataBlock = datalayerADL;
        window.tc_vars = tagCommanderPayload;
    },

    setTagCommanderPayload(tcDataLayer) {
        const tagCommanderPayload = {
            edap_visitor_type: tcDataLayer?.visitortype,
            event_page_funnel_location: tcDataLayer?.pagetype,
            event_page_name: tcDataLayer?.pagename,
            identifiers_device_user_agent_id: tcDataLayer?.visitorid,
            identifiers_session_id: tcDataLayer?.sessionid,
            point_of_sale_eg_brand_name: tcDataLayer?.monikerbrand,
            vrbo_triad: tcDataLayer?.listingid,
            search_request_trip_start_date: tcDataLayer?.startdate,
            search_request_trip_end_date: tcDataLayer?.enddate,
            lodging_directory_id: tcDataLayer?.lodgingDirectoryId,
        };
        return tagCommanderPayload;
    },

    pageview(updateAnalyticsdatalayer) {
        // If analytics is disabled then just short-circuit and bail
        if (analyticsEnabled === false) {
            return;
        }

        let lbsUuids = sessionStorage.getItem('lbsUuids');
        let lbsUuid = null;

        try {
            if (lbsUuids) {
                lbsUuids = JSON.parse(lbsUuids);

                lbsUuid =
                    lbsUuids.placeHierarchy &&
                    lbsUuids.placeHierarchy.length > 1
                        ? lbsUuids.placeHierarchy[1].uuid
                        : null;
            }
        } catch (error) {
            console.error('Error parsing JSON:', error);
        }

        updateAnalyticsdatalayer.lbsuuid = lbsUuid;

        window.analyticsdatalayer = Object.assign(
            window.analyticsdatalayer,
            updateAnalyticsdatalayer
        );

        window.edap.push((edapInstance) => {
            edapInstance.trigger('edap.flush');
            edapInstance.trigger('pageview');
        });
    },

    genericClick(eventAction) {
        tcAnalytics.analyticsEvent('generic.click', {
            eventcategory: 'traveler checkout',
            eventaction: eventAction,
        });
    },

    genericEvent(eventAction, eventCategory) {
        tcAnalytics.analyticsEvent('generic.event', {
            eventcategory: eventCategory || 'traveler checkout',
            eventaction: eventAction,
        });
    },

    genericModal(modalaction, modalname) {
        tcAnalytics.analyticsEvent('generic.modal', {
            modalaction,
            modalname,
        });
    },

    pageUnload() {
        tcAnalytics.analyticsEvent('page.unload');
    },

    genericEventWithLabel(eventAction, eventlabel, eventCategory) {
        tcAnalytics.analyticsEvent('generic.event', {
            eventcategory: eventCategory || 'traveler checkout',
            eventaction: eventAction,
            eventlabel,
        });
    },

    // TODO remove sending logs from here, once we have datadog dashboard for client validations
    namedEvent(eventName, eventDetails, sendLogs = false) {
        tcAnalytics.analyticsEvent(eventName, eventDetails);
        if (sendLogs) {
            logger.log({
                type: 'Client_Validation_Error',
                message: eventDetails?.eventaction,
                errorCode: eventDetails?.ckoerrorcode,
            });
        }
    },

    reservationValidated() {
        tcAnalytics.analyticsEvent('generic.event', {
            eventcategory: 'traveler checkout',
            eventaction: 'reservation validation success',
        });
    },

    logTooltipErrors(errors) {
        tcAnalytics.analyticsEvent('generic.error', {
            logmessage: `TC submit tooltip violation: ${errors}`,
        });
    },

    trackEvent(e) {
        let ele = $(e.target);
        let eventAction = ele.data('event-action');
        let eventMixpanel = ele.data('event-mixpanel');

        if (_.isString(eventAction)) {
            tcAnalytics.genericClick(eventAction);
        }

        if (_.isString(eventMixpanel)) {
            nativeAnalytics.trackEvent(eventMixpanel);
        }
    },

    createConfirmationAdl(data, checkoutType) {
        /**
         * Base analytics only applicable for OLB flows
         * Attempt to use appOptions and fallback to the quote (https://jira.homeawaycorp.com/browse/CHK-10612)
         */
        const {checkinDate, checkoutDate, numAdults, numChildren, numInfants} =
            data.quoteDetails?.quote || {};
        let analyticsObj = {
            startdate: checkinDate,
            enddate: checkoutDate,
            numadults: `${appOptions.get('adults') || numAdults}`,
            numchildren: `${appOptions.get('children') || numChildren}`,
            numinfants: `${appOptions.get('infants') || numInfants}`,
            withpets: `${appOptions.get('petIncluded')}`,
        };

        // Need to remove AOE analytics value fetching here in the else block.
        if (data.quoteDetails?.priceDetails?.edapQuoteSuccess) {
            const pdEdapSuccess = JSON.parse(
                data.quoteDetails.priceDetails.edapQuoteSuccess
            );

            analyticsObj = {
                bookingid: data.confirmationAnalytics?.reservationid,
                displayquotetotal: _.get(pdEdapSuccess, 'displayquotetotal'),
                fullorderrentalrate: _.get(
                    pdEdapSuccess,
                    'fullorderrentalrate'
                ),
                paymentTransactionGuid:
                    data.paymentRequests?.[0]?.paymentRequestUUID,
                currency:
                    data.quoteDetails?.quote?.currencyCode ||
                    appOptions.get('currency'),
                servicefee: _.get(pdEdapSuccess, 'servicefeeamount'),
                ...analyticsObj,
            };
        } else {
            // paypal resume order flow uses doesn't have a quoteDetails object
            // but has confirmationAnalytics.reservationid and data.paymentRequests[0].paymentRequestUUID
            // for bookingid and paymentTransactionGuid
            analyticsObj = {
                bookingid:
                    data.quoteGuid || data.confirmationAnalytics?.reservationid,
                displayquotetotal:
                    `${_.get(
                        data,
                        'quoteTotals.amountForTraveler.amount',
                        ''
                    )}` || data.confirmationAnalytics?.displayquotetotal,
                paymentTransactionGuid:
                    data.paymentTransactionGuid ||
                    data.paymentRequests?.[0]?.paymentRequestUUID,
                currency: data.currencyCode || appOptions.get('currency'),
                servicefee:
                    travelerFeeHelper.has(data.fees).toString() ||
                    data.confirmationAnalytics?.servicefee,
                ...analyticsObj,
            };
        }

        switch (checkoutType) {
            case constants.CHECKOUT_TYPES.OLB_CHECKOUT:
                analyticsObj.pageflow =
                    constants.analytics.CONFIRMATION_PAGE_OLB_PAGE_TYPE;
                analyticsObj.pagetype =
                    constants.analytics.CONFIRMATION_PAGE_OLB_PAGE_TYPE;
                analyticsObj.pagename =
                    constants.analytics.CONFIRMATION_PAGE_OLB_PAGE_NAME;
                analyticsObj.pageurl =
                    constants.analytics.CONFIRMATION_PAGE_OLB_PAGE_URL;
                break;

            case constants.CHECKOUT_TYPES.OLP_CHECKOUT:
                analyticsObj.pageflow =
                    constants.analytics.CONFIRMATION_PAGE_OLP_PAGE_TYPE;
                analyticsObj.pagetype =
                    constants.analytics.CONFIRMATION_PAGE_OLP_PAGE_TYPE;
                analyticsObj.pagename =
                    constants.analytics.CONFIRMATION_PAGE_OLP_PAGE_NAME;
                analyticsObj.pageurl =
                    constants.analytics.CONFIRMATION_PAGE_OLP_PAGE_URL;
                break;

            case constants.CHECKOUT_TYPES.VAS_CART_CHECKOUT:
                analyticsObj.pageflow =
                    constants.analytics.VAS_CART_CONFIRMATION_PAGE_TYPE;
                analyticsObj.pagetype =
                    constants.analytics.VAS_CART_CONFIRMATION_PAGE_TYPE;
                analyticsObj.pagename =
                    constants.analytics.VAS_CART_CONFIRMATION_PAGE_NAME;
                analyticsObj.pageurl =
                    constants.analytics.VAS_CART_CONFIRMATION_PAGE_URL;
                break;

            default:
                analyticsObj.pageflow =
                    constants.analytics.UNKNOWN_CONFIRMATION_PAGE_TYPE;
                analyticsObj.pagetype =
                    constants.analytics.UNKNOWN_CONFIRMATION_PAGE_TYPE;
                analyticsObj.pagename =
                    constants.analytics.UNKNOWN_CONFIRMATION_PAGE_NAME;
        }

        // CHK-765 track whether or not there is a phone number for the owner
        let testattributes = this.buildTestAttributes(data.quoteDetails);
        if (
            !_.isObject(data.contactInfo) ||
            (_.isUndefined(data.contactInfo.primaryPhone) &&
                _.isUndefined(data.contactInfo.secondaryPhone) &&
                _.isUndefined(data.contactInfo.tertiaryPhone))
        ) {
            testattributes += ',conumfalse';
        } else {
            testattributes += ',conumtrue';
        }

        const finalADLObject = {
            ...data.confirmationAnalytics,
            ...analyticsObj,
            testattributes,
        };

        // VCHK-11010 - adding splunk log to get more data around 0.00 value for displayquotetotal
        if (utility.isNativeMobileRequest()) {
            logger.log({
                key: 'VCHK-11010: Investigate missing displayquotetotal for mweb',
                values: {
                    isNativeMobileAndroid: utility.isNativeMobileAndroid(),
                    isNativeMobileIOS: utility.isNativeMobileIOS(),
                    checkoutType,
                    // if hasEdapQuoteSuccess is false, might be paypal flow
                    hasEdapQuoteSuccess: data.quoteDetails?.priceDetails
                        ?.edapQuoteSuccess
                        ? true
                        : false,
                    currency: finalADLObject.currency,
                    displayquotetotal: finalADLObject.displayquotetotal,
                    total: data.quoteDetails?.quote?.total?.decimalAmount,
                    quoteTotals: data.quoteDetails?.quote?.quoteTotals,
                    finalADLObject,
                },
            });
        }
        return finalADLObject;
    },

    /**
     * This function is the "confirmation" page view tracking that is called in base/checkout and vas interstitial
     * More information can be found here: CHK-3780
     * @param {json} checkoutResponseData
     * @param {func} callback
     */
    confirmationAnalyticsPageView(checkoutResponseData = {}, callback) {
        const confirmationAdlPart1 = {
            sensitive: 'false',
        };
        let checkoutType;

        const supportedPaymentMode =
            checkoutResponseData?.quoteDetails?.supportedPaymentMode ||
            checkoutResponseData?.supportedPaymentMode;
        if (!_.isUndefined(supportedPaymentMode)) {
            confirmationAdlPart1.onlinepayments = supportedPaymentMode;
        }

        // override checkout type if specified
        if (!_.isUndefined(checkoutResponseData?.checkoutType)) {
            checkoutType = checkoutResponseData.checkoutType;
        }
        const confirmationAdlPart2 = this.createConfirmationAdl(
            checkoutResponseData,
            checkoutType || appOptions.get('checkoutType')
        );

        this.pageUnload();

        tcAnalytics.pageview({
            ...confirmationAdlPart1,
            ...confirmationAdlPart2,
        });

        callback && callback();
    },

    trackPicketlineEvent(event, properties) {
        if (nativeAnalytics.isEnabled()) {
            nativeAnalytics.trackEventWithProperties(event, properties);
            // Ensure we do not duplicate events between web + native
            return;
        }
        tcAnalytics.analyticsEvent(event, properties);
    },

    /**
     * Analytics moved from legacy checkoutController
     **/
    processAnalytics({
        checkoutInputs,
        quote,
        listing,
        propertyDetailsAnalytics,
        tripId,
        currentPaymentRequest,
        error,
    }) {
        const checkoutType = window.__INITIAL_STATE__.flow;
        let adl = {
            startdate: appOptions.get('checkinDate'),
            enddate: appOptions.get('checkoutDate'),
            numadults: `${appOptions.get('adults')}`,
            numchildren: `${appOptions.get('children')}`,
            numinfants: `${appOptions.get('infants')}`,
            withpets: `${appOptions.get('petIncluded')}`,
            sensitive: 'true',
            ...propertyDetailsAnalytics,
        };

        if (checkoutType === 'OLP') {
            adl.pageflow = constants.analytics.CHECKOUT_PAGE_OLP_PAGE_TYPE;
            adl.pagetype = constants.analytics.CHECKOUT_PAGE_OLP_PAGE_TYPE;

            // Set missing appOptions variables that come from query url
            appOptions.set('unitIdentity', appOptions.get('listingId'));
            appOptions.set('adults', _.get(checkoutInputs, 'adults'));
            appOptions.set('children', _.get(checkoutInputs, 'children'));
            appOptions.set('petIncluded', _.get(checkoutInputs, 'withPets'));
            appOptions.set('checkinDate', _.get(checkoutInputs, 'arrivalDate'));
            appOptions.set(
                'checkoutDate',
                _.get(checkoutInputs, 'departureDate')
            );

            adl = Object.assign(adl, {
                listingid: appOptions.get('unitIdentity'),
                bookingid: appOptions.get('quoteGuid'),
                propertyid: _.get(listing, 'propertyId'),
                pagename: constants.analytics.CHECKOUT_PAGE_OLP_PAGE_NAME,
                pageurl: `${constants.analytics.CHECKOUT_PAGE_OLP_PAGE_URL}${config.params.searchPath}`,
            });
        } else if (checkoutType === 'OLB') {
            const pagename = constants.analytics.CHECKOUT_PAGE_OLB_PAGE_NAME;
            const pageurl = constants.analytics.CHECKOUT_PAGE_OLB_PAGE_URL;

            adl.pageflow = constants.analytics.CHECKOUT_PAGE_OLB_PAGE_TYPE;
            adl.pagetype = constants.analytics.CHECKOUT_PAGE_OLB_PAGE_TYPE;
            adl = Object.assign(adl, {
                listingid: appOptions.get('unitIdentity'),
                propertyid: _.get(listing, 'propertyId'),
                pagename,
                pageurl,
            });
        }

        if (!error && !_.isNull(quote)) {
            const hasTravelerFee = quote.fees
                ? travelerFeeHelper.has(quote.fees)
                : false;
            const currentPaymentRequestNumber =
                _.isObject(currentPaymentRequest) &&
                _.isNumber(currentPaymentRequest.paymentNumber)
                    ? currentPaymentRequest.paymentNumber
                    : 1;
            const numberOfPaymentRequests = quote.numberOfPaymentRequests;

            adl = Object.assign(adl, {
                servicefee: hasTravelerFee.toString(),
                paymentsplit: `${currentPaymentRequestNumber}/${numberOfPaymentRequests}`,
            });
        }

        // Add the trip id
        adl.tripid = tripId;

        if (listing) {
            const address = listing.address || {};
            const geoCode = listing.geoCode || {};

            Object.assign(adl, {
                country: address.country || '-1',
                locality: address.city || '-1',
                postalcode: address.postalCode || '-1',
                admin1: address.stateProvince || address.country || '-1',
                latitude: `${geoCode.latitude || -1}`,
                longitude: `${geoCode.longitude || -1}`,
                calendarlastupdated: listing.availabilityUpdated,
                lodgingDirectoryId: listing.lodgingDirectoryId,
            });

            // https://jira.expedia.biz/browse/VCHK-11212 - log when events contain -1 for the following fields
            if (
                adl.listingid === '-1' ||
                adl.locality === '-1' ||
                adl.country === '-1'
            ) {
                logger.log({
                    key: 'VCHK-11212 - Missing listing fields',
                    value: {
                        listing,
                        checkoutType,
                        adl,
                    },
                });
            }
        }

        return adl;
    },

    processPaymentForAnalytics(checkoutModel) {
        // TODO: remove deep dependency on checkoutModel
        return {
            fullorderrentalrate: `${utility.determineFullorderrentalrate(
                checkoutModel
            )}`,
            displayprice: `${utility.determineNightlyFees(checkoutModel)}`,
            displayquotetotal: `${utility.determineDisplayQuoteTotal(
                checkoutModel
            )}`,
            partnerfeesamount: `${utility.determinePartnerFeesAmount(
                checkoutModel
            )}`,
            numpartnerfees: `${utility.getOwnerFees(checkoutModel)}`,
            servicefeeamount: `${utility.determineServiceFeeAmount(
                checkoutModel
            )}`,
            ordertax: `${utility.determineOrderTax(checkoutModel)}`,
            ordertotal: `${utility.determineOrderTotal(checkoutModel)}`,
            rdd: `${utility.getRddAmount(checkoutModel)}`,
            pdp: `${utility.getPdpAmount(checkoutModel)}`,
            currency: `${_.get(
                checkoutModel.get('quote'),
                'currencyCode',
                -1
            )}`,
            onlinepayments: checkoutModel.get('quote').supportedPaymentMode,
        };
    },

    processPanelAnalytics(panel) {
        const checkoutModel = window.TC.checkoutModel; // pull from window object instead of passing checkoutModel around?
        const checkoutType = window.__INITIAL_STATE__.flow;
        let adl = {
            listingid: appOptions.get('unitIdentity'),
            propertyid: _.get(checkoutModel.get('listing'), 'propertyId'),
            ...this.processPaymentForAnalytics(checkoutModel),
            ...this.processWalletForAnalytics(checkoutModel),
            ...this.buildTestAttributes(checkoutModel.toJSON()),
            ...this.processAnalytics({
                checkoutInputs:
                    checkoutModel.get('rawResponse')?.checkoutInputs,
                quote: checkoutModel.get('quote'),
                listing: checkoutModel.get('listing'),
                propertyDetailsAnalytics: checkoutModel.get(
                    'propertyDetailsAnalytics'
                ),
                tripId: checkoutModel.get('tripId') || '-1',
            }),
        };
        if (
            checkoutType === 'OLP' &&
            checkoutType === appOptions.get('checkoutType')
        ) {
            switch (panel) {
                case constants.PANELS.RULES:
                    adl = Object.assign(adl, {
                        pagename: constants.analytics.RULES_PAGE_OLP_PAGE_NAME,
                        pageurl: `${constants.analytics.RULES_PAGE_OLP_PAGE_URL}${config.params.searchPath}`,
                    });
                    break;
                case constants.PANELS.TRIP_PROTECTION:
                    adl = Object.assign(adl, {
                        pagename:
                            constants.analytics.TRIP_PROTECTION_OLP_PAGE_NAME,
                        pageurl: `${constants.analytics.TRIP_PROTECTION_OLP_PAGE_URL}${config.params.searchPath}`,
                    });
                    break;
                case constants.PANELS.PAYMENT:
                    adl = Object.assign(adl, {
                        pagename:
                            constants.analytics.PAYMENT_PAGE_OLP_PAGE_NAME,
                        pageurl: `${constants.analytics.PAYMENT_PAGE_OLP_PAGE_URL}${config.params.searchPath}`,
                    });
                    break;
                case constants.PANELS.VAS:
                    adl = Object.assign(adl, {
                        pagename:
                            constants.analytics.VAS_INTERSTITIAL_OLP_PAGE_NAME,
                        pageurl: `${constants.analytics.VAS_INTERSTITIAL_OLP_PAGE_URL}${config.params.searchPath}`,
                    });
                    break;
                case constants.PANELS.CONTACT_DETAILS:
                    adl = Object.assign(adl, {
                        pagename:
                            constants.analytics.CHECKOUT_PAGE_OLP_PAGE_NAME,
                        pageurl: constants.analytics.CHECKOUT_PAGE_OLP_PAGE_URL,
                    });
                    break;
                default:
                    break;
            }
        } else if (
            checkoutType === 'OLB' &&
            checkoutType === appOptions.get('checkoutType')
        ) {
            switch (panel) {
                case constants.PANELS.RULES:
                    adl = Object.assign(adl, {
                        pagename: constants.analytics.RULES_PAGE_OLB_PAGE_NAME,
                        pageurl: constants.analytics.RULES_PAGE_OLB_PAGE_URL,
                    });
                    break;
                case constants.PANELS.TRIP_PROTECTION:
                    adl = Object.assign(adl, {
                        pagename:
                            constants.analytics.TRIP_PROTECTION_OLB_PAGE_NAME,
                        pageurl:
                            constants.analytics.TRIP_PROTECTION_OLB_PAGE_URL,
                    });
                    break;
                case constants.PANELS.PAYMENT:
                    adl = Object.assign(adl, {
                        pagename:
                            constants.analytics.PAYMENT_PAGE_OLB_PAGE_NAME,
                        pageurl: constants.analytics.PAYMENT_PAGE_OLB_PAGE_URL,
                    });
                    break;
                case constants.PANELS.VAS:
                    adl = Object.assign(adl, {
                        pagename:
                            constants.analytics.VAS_INTERSTITIAL_OLB_PAGE_NAME,
                        pageurl:
                            constants.analytics.VAS_INTERSTITIAL_OLB_PAGE_URL,
                    });
                    break;
                case constants.PANELS.CONTACT_DETAILS:
                    adl = Object.assign(adl, {
                        pagename:
                            constants.analytics.CHECKOUT_PAGE_OLB_PAGE_NAME,
                        pageurl: constants.analytics.CHECKOUT_PAGE_OLB_PAGE_URL,
                    });
                    break;
                default:
                    break;
            }
        }

        this.pageUnload();
        this.pageview(adl);
    },

    processWalletForAnalytics(checkoutModel) {
        const walletDetails = {
            travelerwallet: 'false',
            numcards: '0',
            numcardsexpired: 0,
            numcardsunsupported: 0,
            numcardsvalid: 0,
            savecard: 'true',
            savecardpreselected: 'false',
        };
        if (
            checkoutModel.get('loggedInTravelerInfo') &&
            checkoutModel.get('loggedInTravelerInfo').email
        ) {
            walletDetails.travelerwallet = 'true';
        }

        const shouldSaveCardPreselected = () => {
            return (
                !_.isEmpty(checkoutModel.get('loggedInTravelerInfo')) &&
                !!checkoutModel.get('loggedInTravelerInfo').email &&
                !checkoutModel.get('loggedInTravelerInfo').impersonated &&
                !checkoutModel.get('paymentStepLogin')
            );
        };

        walletDetails.savecardpreselected = shouldSaveCardPreselected()
            ? 'true'
            : 'false';
        if (
            walletDetails.savecard === 'true' &&
            checkoutModel.get('travelerWalletInfo')
        ) {
            walletDetails.numcards = `${_.get(
                checkoutModel.get('travelerWalletInfo'),
                'allSavedPaymentInstrumentsCard.length',
                0
            )}`;
            const allSavedPaymentInstruments =
                checkoutModel.get(
                    'travelerWalletInfo'
                ).allSavedPaymentInstrumentsCard;
            if (allSavedPaymentInstruments) {
                allSavedPaymentInstruments.forEach((savedInstrument) => {
                    if (savedInstrument) {
                        if (
                            savedInstrument.paymentInstrumentStatus ===
                            constants.EXPIRED
                        ) {
                            walletDetails.numcardsexpired++;
                        } else if (
                            !CardTypeUtil.isWalletCardTypeSupported(
                                _.get(
                                    savedInstrument,
                                    'creditCardInfo.cardType'
                                ),
                                checkoutModel.get('supportedCardTypesBootstrap')
                            )
                        ) {
                            walletDetails.numcardsunsupported++;
                        } else {
                            walletDetails.numcardsvalid++;
                        }
                    }
                });
            }
        }
        walletDetails.numcardsexpired = `${walletDetails.numcardsexpired}`;
        walletDetails.numcardsunsupported = `${walletDetails.numcardsunsupported}`;
        walletDetails.numcardsvalid = `${walletDetails.numcardsvalid}`;
        if (checkoutModel.get('publicuuid')) {
            walletDetails.publicuuid = checkoutModel.get('publicuuid');
        }
        return walletDetails;
    },
};

export default tcAnalytics;
